import { useContext } from "react";
import { AccrualReviewCtx } from "./accrualReview.context";

export function useAccrualReviewContext() {
    return useContext(AccrualReviewCtx);
}
